import axios from "axios";
import apiUrl from '../configs/constant';

const instance = axios.create({
    baseURL: `${apiUrl.apiUrl}`
});

instance.interceptors.request.use((config) => {
    const user = localStorage.getItem("user");
    if (user) {
        const token = JSON.parse(user).token;
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem("user");
            window.location.href = "/login"; // Arahkan ke halaman login
        }
        return Promise.reject(error);
    }
);

export default instance;
